module.exports = __webpack_public_path__ + "img/shanghaixuhui.d4735dde.png";